export const CART_ITEM_STATUS_CAN_ORDER = 10;
export const CART_ITEM_STATUS_ORDERED = 20;
export const CART_ITEM_STATUS_LOSE_EFFICACY = 30;

export const CART_ITEM_STATUS = {
  [CART_ITEM_STATUS_CAN_ORDER]: '可下单',
  [CART_ITEM_STATUS_ORDERED]: '已下单',
  [CART_ITEM_STATUS_LOSE_EFFICACY]: '已失效'
}
